import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import {
    TbArrowBarToRight,
    TbArrowBackUp,
    TbCornerUpLeft
} from 'react-icons/tb';
import Helmet from 'components/Helmet';
import axios from 'config/axios';
import { useAppDispatch } from 'hooks/useStore';
import { setError } from 'store/error';
import './index.css';
import ButtonLink from 'components/ButtonLink';

function QuizResult() {
    const [isLoading, setIsLoading] = useState(true);
    const [quizName, setQuizName] = useState('');
    const [passed, setPassed] = useState(false);
    const [numCorrect, setNumCorrect] = useState(0);
    const [numQuestions, setNumQuestions] = useState(0);
    const [explanationVideoUrl, setExplanationVideoUrl] = useState('');
    const [progress, setProgress] = useState(0);
    const [postTestId, setPostTestId] = useState('');

    const dispatch = useAppDispatch();
    const { courseUrl, quizNum } = useParams();

    useEffect(() => {
        axios.get(`courses/classroom/${courseUrl}/quiz/${quizNum}/result/`)
            .then(res => {
                const {
                    name,
                    passed,
                    numCorrect,
                    numQuestions,
                    progress,
                    explanationVideoUrl,
                    postTestId,
                } = res.data;
                setQuizName(name);
                setPassed(passed);
                setNumCorrect(numCorrect);
                setNumQuestions(numQuestions);
                setExplanationVideoUrl(explanationVideoUrl);
                setProgress(progress);
                setPostTestId(postTestId);
                setIsLoading(false);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }, []);

    if (isLoading) return <></>;

    return (
        <div className='quizResult__wrapper'>
            <Helmet
                title={`${quizName} Result - The Digital SAT Crash Course`}
            />
            <div className='quizResult'>
                <h1 className='quizResult__title'>{quizName} Result</h1>
                {passed
                ?   <p className='quizResult__result'>
                        Congrats!<br/>
                        You scored <span className='quizResult__passed'>{numCorrect}/{numQuestions}</span> and you are ready to move on!
                    </p>
                :   <p className='quizResult__result'>
                        <span>Uh-oh,</span>
                        <span>You got {numCorrect} correct out of {numQuestions} questions.<br/></span>
                        <span>Try to go over 70% to move on to the next section</span>
                        <span className='quizResult__percent'>{Math.floor(numCorrect/numQuestions*100)}% Correct</span>
                    </p>
                }
                <div className='quizResult__buttons'>
                    {progress >= 100
                    ?   <ButtonLink
                            className='testCard__emailButton'
                            secondary
                            to={`test/${postTestId}`}
                        >
                            TAKE POST TEST
                        </ButtonLink>
                    :   passed
                    ?   <ButtonLink
                            className='testCard__emailButton'
                            to={`/courses/${courseUrl}`}
                        >
                            GO TO NEXT TOPIC
                        </ButtonLink>
                    :   <ButtonLink
                            className='testCard__emailButton'
                            secondary
                            to={`/courses/${courseUrl}`}
                        >
                            REWATCH LECTURES
                        </ButtonLink>
                    }   
                    {passed
                    ?   <></>
                    :   <ButtonLink
                                className='testCard__emailButton'
                                secondary
                                to={`/courses/${courseUrl}/quiz/${quizNum}`}
                            >
                                BACK TO QUIZ
                        </ButtonLink>
                    }
                    <ButtonLink
                            className='testCard__emailButton'
                            secondary={passed? true : false}
                            to={`/courses/${courseUrl}/quiz/${quizNum}/review`}
                        >
                            REVIEW QUESTIONS
                    </ButtonLink>
                </div>
            </div>
        </div>
    );
}

export default QuizResult;